/**
 * 🌲 PRESENTATION EXTRACTOR (Robust Mapping)
 */
export default function extractPresentation(rows, indexMap) {
  console.group("🌲 [EXTRACTOR:PRES] Internal Trace");
  const concepts = {};
  const roots = [];
  const stack = [];

  // 🎯 FUZZY KEY LOOKUP: Stop the silent "undefined" errors
  const getIdx = (target) => {
    const key = Object.keys(indexMap).find(k => 
      k.toLowerCase().trim() === target.toLowerCase().trim()
    );
    return indexMap[key];
  };

  const L_IDX = getIdx("Level");
  const T_IDX = getIdx("Technical Name");
  const A_IDX = getIdx("Abstract");
  const E_IDX = getIdx("Label en");

  console.log(`📍 Map Resolution -> Level: ${L_IDX}, ID: ${T_IDX}, Label: ${E_IDX}`);

  if (L_IDX === undefined || T_IDX === undefined) {
    console.error("❌ CRITICAL: Could not find required columns in Presentation sheet.", indexMap);
    console.groupEnd();
    return { concepts: {}, roots: [] };
  }

  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const id = r[T_IDX];
    const level = parseInt(r[L_IDX]);
    const label = r[E_IDX];
    const isAbstract = String(r[A_IDX] || "").toLowerCase() === 'true';

    // If ID is missing, we skip. If EVERY ID is missing, we get Roots: 0.
    if (!id || isNaN(level)) continue;

    const node = { id, label: label || id, isAbstract, children: [], parent: null };
    concepts[id] = node;

    if (level === 1) {
      roots.push(id);
      stack[0] = node;
    } else {
      const parentNode = stack[level - 2];
      if (parentNode) {
        parentNode.children.push(id);
        node.parent = parentNode.id;
      }
      stack[level - 1] = node;
    }
  }

  console.log(`✅ Extraction Complete. Roots: ${roots.length}`);
  console.groupEnd();
  return { concepts, roots };
}